// Agency student casting profile container handling profile data and media interactions.
// Mistake note: Intro video thumbnail/playback was custom-implemented here, causing broken fallback and inconsistency; reuse shared VideoPlayer to avoid drift.
import { useEffect, useState } from "react";
import ProfileForAgencyComponent from "./ProfileForAgency.component";
import { fetchStudentProfileForAgency, increaseStudentIntroVideoViewCount, increaseStudentProfilePhotoViewCount } from "api/agency/v2/Student.api";

import { useSelector } from "react-redux";
import { usePopup } from "contexts/PopupContext";
import ImageWithWatermarkForPresignedUrlPopupContainer from "pages/agency/v2/popup/ImageWithWatermarkForPresignedUrlPopup.container";

const ProfileForAgencyContainer = (props: any) => {
    const { info: myInfo } = useSelector((state: any) => state.user);
    const { showPopup } = usePopup();
    const { userStudentId } = props;
    const [isInit, setIsInit] = useState(false);
    const [info, setInfo] = useState<any>(null);
    const [isIntroVideoViewCountIncreased, setIsIntroVideoViewCountIncreased] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string>("");

    const fetchInfo = async () => {
        try {
            const data = await fetchStudentProfileForAgency(userStudentId);
            if (data?.info) {
                let newInfo = { ...data.info };
                setInfo(newInfo);
            }
        } catch (error: any) {
            console.error("pages/agency/v2/student/ProfileForAgency.container::fetchInfo error", error);
            setErrorMessage(error.message || "프로필 정보를 불러오는데 실패했습니다.");
        } finally {
            setIsInit(true);
        }
    };

    useEffect(() => {
        fetchInfo();
    }, []);

    const handleIntroVideoPlayStart = async () => {
        if (isIntroVideoViewCountIncreased) return;
        if (!info?.profileIntroVideoInfo?.id) return;
        try {
            await increaseStudentIntroVideoViewCount(userStudentId, info.profileIntroVideoInfo.id);
            setIsIntroVideoViewCountIncreased(true);
        } catch (error) {
            console.error("Failed to increase intro video view count", error);
        }
    };

    const handleClickImage = async (profileImageId: number, imageId: string) => {
        console.log("pages/agency/v2/student/ProfileForAgency.container::handleClickImage");

        showPopup(
            <ImageWithWatermarkForPresignedUrlPopupContainer
                imageId={imageId}
                watermarkText={myInfo?.agencyName + " " + myInfo?.username}
            />
        );

        await increaseStudentProfilePhotoViewCount(userStudentId, profileImageId);
    };

    return <ProfileForAgencyComponent
        isInit={isInit}
        info={info}
        onIntroVideoPlayStart={handleIntroVideoPlayStart}
        myInfo={myInfo}
        onClickImage={handleClickImage}
        errorMessage={errorMessage}
    />;
};

export default ProfileForAgencyContainer;